import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  FiSave, FiArrowLeft, FiUser, FiMail, FiLock,
  FiShield, FiEye, FiEyeOff, FiCheck, FiAtSign,
  FiSearch, FiLink, FiX
} from 'react-icons/fi';
import { toast } from 'react-toastify';
import { userService } from '../../services/api';
import api from '../../services/api';
import './CadastroUsuario.css';

const MODULOS = [
  { key: 'dashboard',        label: 'Dashboard',           soLeitura: true },
  { key: 'colaboradores',    label: 'Colaboradores'                         },
  { key: 'reunioes',         label: 'Reuniões'                              },
  { key: 'presencas',        label: 'Presenças'                             },
  { key: 'irmandade',        label: 'Irmandade'                             },
  { key: 'visitas',          label: 'Visitas'                               },
  { key: 'cargos',           label: 'Cargos'                                },
  { key: 'congregacoes',     label: 'Congregações'                          },
  { key: 'relatorios',       label: 'Relatórios',          soLeitura: true  },
  { key: 'recitativos',      label: 'Recitativos'                           },
  { key: 'reuniao_jovens',   label: 'Reunião de Jovens'                     },
  { key: 'reuniao_criancas', label: 'Reunião de Crianças'                   },
  { key: 'rota_visitas',     label: 'Rota de Visitas'                       },
  { key: 'usuarios',         label: 'Usuários'                              },
];

const PERMISSOES_POR_ROLE = {
  admin: Object.fromEntries(MODULOS.map(m => [m.key, { read: true, write: !m.soLeitura }])),
  editor: {
    dashboard:           { read: true,  write: false },
    colaboradores:       { read: true,  write: true  },
    reunioes:            { read: true,  write: true  },
    presencas:           { read: true,  write: true  },
    irmandade:           { read: true,  write: true  },
    visitas:             { read: true,  write: true  },
    cargos:              { read: true,  write: true  },
    congregacoes:        { read: true,  write: true  },
    relatorios:          { read: true,  write: false },
    recitativos:         { read: true,  write: true  },
    reuniao_jovens:      { read: true,  write: true  },
    reuniao_criancas:    { read: true,  write: true  },
    rota_visitas:        { read: true,  write: true  },
    usuarios:            { read: false, write: false },
  },
  viewer: Object.fromEntries(MODULOS.map(m => [m.key, { read: true, write: false }])),
  auxiliar: {
    dashboard:           { read: true,  write: false },
    colaboradores:       { read: false, write: false },
    reunioes:            { read: false, write: false },
    presencas:           { read: false, write: false },
    irmandade:           { read: true,  write: false },
    visitas:             { read: false, write: false },
    cargos:              { read: false, write: false },
    congregacoes:        { read: false, write: false },
    relatorios:          { read: false, write: false },
    recitativos:         { read: true,  write: true  },
    reuniao_jovens:      { read: false, write: false },
    reuniao_criancas:    { read: false, write: false },
    rota_visitas:        { read: false, write: false },
    usuarios:            { read: false, write: false },
  },
  reuniao_criancas: {
    dashboard:           { read: true,  write: false },
    colaboradores:       { read: false, write: false },
    reunioes:            { read: false, write: false },
    presencas:           { read: false, write: false },
    irmandade:           { read: true,  write: true  },
    visitas:             { read: false, write: false },
    cargos:              { read: false, write: false },
    congregacoes:        { read: true,  write: false },
    relatorios:          { read: false, write: false },
    recitativos:         { read: false, write: false },
    reuniao_jovens:      { read: false, write: false },
    reuniao_criancas:    { read: true,  write: true  },
    rota_visitas:        { read: false, write: false },
    usuarios:            { read: false, write: false },
  },
};

const permissoesVazias = () =>
  Object.fromEntries(MODULOS.map(m => [m.key, { read: false, write: false }]));

const CadastroUsuario = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditing = Boolean(id);

  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(isEditing);
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [personalizarPerms, setPersonalizarPerms] = useState(false);

  // ── Vínculo com colaborador ───────────────────────────────────────────────
  const [colaboradores, setColaboradores] = useState([]);
  const [colaboradorSelecionado, setColaboradorSelecionado] = useState(null);
  const [buscaColab, setBuscaColab] = useState('');
  const [buscaAberta, setBuscaAberta] = useState(false);
  const buscaColabRef = useRef(null);
  const buscaWrapRef = useRef(null);

  const [formData, setFormData] = useState({
    nome: '',
    usuario: '',
    email: '',
    senha: '',
    permissao: 'viewer',
    ativo: true,
    email_aniversariantes_tipo: 'desativado',
  });

  const [modulos, setModulos] = useState(PERMISSOES_POR_ROLE.viewer);

  useEffect(() => {
    if (isEditing) carregarUsuario();
  }, [id, isEditing]);

  useEffect(() => {
    api.get('/colaboradores').then(r => {
      const lista = Array.isArray(r.data) ? r.data : [];
      setColaboradores(lista.sort((a, b) =>
        (a.nome_completo || a.nomeCompleto || '').localeCompare(b.nome_completo || b.nomeCompleto || '', 'pt-BR')
      ));
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (buscaWrapRef.current && !buscaWrapRef.current.contains(e.target)) {
        setBuscaAberta(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const nomeColab = (c) => c?.nome_completo || c?.nomeCompleto || '';

  const colabFiltrados = buscaColab.trim().length > 0
    ? colaboradores.filter(c => nomeColab(c).toLowerCase().includes(buscaColab.toLowerCase()))
    : colaboradores;

  const selecionarColab = (c) => {
    setColaboradorSelecionado(c);
    setBuscaAberta(false);
    setBuscaColab('');
    const nome = nomeColab(c);
    const email = c.email || '';
    setFormData(prev => ({
      ...prev,
      nome: nome || prev.nome,
      email: email || prev.email,
    }));
  };

  const limparColab = () => {
    setColaboradorSelecionado(null);
    setBuscaColab('');
  };

  const carregarUsuario = async () => {
    try {
      const response = await userService.getById(id);
      if (response.success) {
        const d = response.data;
        setFormData({
          nome: d.nome || '',
          usuario: d.usuario || '',
          email: d.email || '',
          senha: '',
          permissao: d.permissao || 'viewer',
          ativo: d.ativo !== undefined ? d.ativo : true,
          email_aniversariantes_tipo:
            d.email_aniversariantes_tipo || d.emailAniversariantesTipo || 'desativado',
        });
        const perms = d.permissoes_modulos || d.permissoesModulos;
        if (perms && typeof perms === 'object' && Object.keys(perms).length > 0) {
          setModulos(perms);
          // Verificar se difere do padrão da role
          const padrao = PERMISSOES_POR_ROLE[d.permissao] || PERMISSOES_POR_ROLE.viewer;
          const differ = JSON.stringify(perms) !== JSON.stringify(padrao);
          setPersonalizarPerms(differ);
        } else {
          setModulos(PERMISSOES_POR_ROLE[d.permissao] || PERMISSOES_POR_ROLE.viewer);
        }
      }
    } catch (error) {
      toast.error('Erro ao carregar dados do usuário');
      navigate('/usuarios');
    } finally {
      setLoadingData(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;

    if (name === 'permissao' && !personalizarPerms) {
      setModulos(PERMISSOES_POR_ROLE[value] || PERMISSOES_POR_ROLE.viewer);
    }

    setFormData(prev => ({ ...prev, [name]: newValue }));
  };

  const handlePersonalizar = (e) => {
    setPersonalizarPerms(e.target.checked);
    if (!e.target.checked) {
      setModulos(PERMISSOES_POR_ROLE[formData.permissao] || PERMISSOES_POR_ROLE.viewer);
    }
  };

  const toggleRead = (key) => {
    setModulos(prev => {
      const cur = prev[key];
      const novoRead = !cur.read;
      return {
        ...prev,
        [key]: {
          read: novoRead,
          write: novoRead ? cur.write : false,
        }
      };
    });
  };

  const toggleWrite = (key) => {
    setModulos(prev => {
      const cur = prev[key];
      const novoWrite = !cur.write;
      return {
        ...prev,
        [key]: {
          read: novoWrite ? true : cur.read,
          write: novoWrite,
        }
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const dados = {
        ...formData,
        permissoes_modulos: modulos,
      };
      if (isEditing && !dados.senha) {
        delete dados.senha;
      }

      const response = isEditing
        ? await userService.update(id, dados)
        : await userService.create(dados);

      if (response.success) {
        toast.success(`Usuário ${isEditing ? 'atualizado' : 'cadastrado'} com sucesso!`);
        navigate('/usuarios');
      } else {
        toast.error(response.message || `Erro ao ${isEditing ? 'atualizar' : 'cadastrar'} usuário`);
      }
    } catch (error) {
      toast.error(error?.response?.data?.error || `Erro ao ${isEditing ? 'atualizar' : 'cadastrar'} usuário`);
    } finally {
      setLoading(false);
    }
  };

  if (loadingData) {
    return (
      <div className="cad-loading">
        <p>Carregando dados...</p>
      </div>
    );
  }

  return (
    <div className="cad-usuario-page">
      <div className="cad-header">
        <button className="btn-voltar" onClick={() => navigate('/usuarios')}>
          <FiArrowLeft /> Voltar
        </button>
        <div>
          <h1><FiUser /> {isEditing ? 'Editar Usuário' : 'Novo Usuário'}</h1>
          <p>{isEditing ? 'Altere os dados e permissões do usuário' : 'Preencha os dados para criar um novo usuário'}</p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="cad-form">

        {/* ── Vincular colaborador ── */}
        {!isEditing && (
          <div className="cad-card cad-card-colab">
            <div className="cad-card-header">
              <FiLink /> Vincular colaborador <span className="cad-opcional">(opcional)</span>
            </div>
            <div className="cad-card-body">
              <p className="cad-colab-hint">
                Selecione um colaborador para pré-preencher o nome e e-mail automaticamente.
              </p>
              <div className="cad-colab-wrap" ref={buscaWrapRef}>
                {/* Campo fechado – mostra selecionado ou placeholder */}
                {!buscaAberta ? (
                  <div
                    className="cad-colab-field"
                    onClick={() => { setBuscaAberta(true); setTimeout(() => buscaColabRef.current?.focus(), 50); }}
                    tabIndex={0}
                    onKeyDown={e => e.key === 'Enter' && setBuscaAberta(true)}
                  >
                    {colaboradorSelecionado ? (
                      <>
                        <FiUser className="cad-colab-icon" />
                        <span className="cad-colab-nome">{nomeColab(colaboradorSelecionado)}</span>
                        {colaboradorSelecionado.cargo_nome && (
                          <span className="cad-colab-cargo">{colaboradorSelecionado.cargo_nome.split(',')[0]}</span>
                        )}
                        <button type="button" className="cad-colab-clear" onClick={e => { e.stopPropagation(); limparColab(); }} title="Remover">
                          <FiX size={13} />
                        </button>
                      </>
                    ) : (
                      <>
                        <FiSearch className="cad-colab-icon cad-colab-icon-muted" />
                        <span className="cad-colab-placeholder">Buscar colaborador...</span>
                      </>
                    )}
                  </div>
                ) : (
                  <div className="cad-colab-search-wrap">
                    <FiSearch className="cad-colab-search-icon" />
                    <input
                      ref={buscaColabRef}
                      type="search"
                      className="cad-colab-search-input"
                      placeholder="Digite o nome..."
                      value={buscaColab}
                      onChange={e => setBuscaColab(e.target.value)}
                      onKeyDown={e => e.key === 'Escape' && setBuscaAberta(false)}
                    />
                    <button type="button" className="cad-colab-clear" onClick={() => setBuscaAberta(false)}>
                      <FiX size={13} />
                    </button>
                  </div>
                )}

                {/* Dropdown */}
                {buscaAberta && (
                  <ul className="cad-colab-dropdown">
                    {colabFiltrados.length === 0 ? (
                      <li className="cad-colab-item cad-colab-vazio">Nenhum colaborador encontrado.</li>
                    ) : (
                      colabFiltrados.slice(0, 50).map(c => (
                        <li key={c.id} className="cad-colab-item" onClick={() => selecionarColab(c)}>
                          <span className="cad-colab-item-nome">{nomeColab(c)}</span>
                          {c.cargo_nome && <span className="cad-colab-item-cargo">{c.cargo_nome.split(',')[0]}</span>}
                          {c.email && <span className="cad-colab-item-email">{c.email}</span>}
                        </li>
                      ))
                    )}
                  </ul>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Dados básicos */}
        <div className="cad-card">
          <div className="cad-card-header">
            <FiUser /> Dados do Usuário
          </div>
          <div className="cad-card-body">
            <div className="cad-grid-2">
              <div className="form-group">
                <label><FiUser /> Nome completo *</label>
                <input
                  type="text"
                  name="nome"
                  value={formData.nome}
                  onChange={handleInputChange}
                  required
                  placeholder="Nome completo"
                />
              </div>
              <div className="form-group">
                <label><FiAtSign /> Nome de usuário <span className="field-hint">(login)</span></label>
                <input
                  type="text"
                  name="usuario"
                  value={formData.usuario}
                  onChange={handleInputChange}
                  placeholder="Ex: joao.silva"
                  autoComplete="off"
                  spellCheck={false}
                />
                <small className="form-hint">Opcional. Se preenchido, pode logar com este nome em vez do e-mail.</small>
              </div>
            </div>

            <div className="cad-grid-2">
              <div className="form-group">
                <label><FiMail /> E-mail *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  placeholder="email@exemplo.com"
                />
              </div>
              <div className="form-group">
                <label><FiLock /> Senha {!isEditing && '*'}</label>
                <div className="input-password">
                  <input
                    type={mostrarSenha ? 'text' : 'password'}
                    name="senha"
                    value={formData.senha}
                    onChange={handleInputChange}
                    required={!isEditing}
                    placeholder={isEditing ? 'Deixe em branco para manter' : 'Mínimo 6 caracteres'}
                  />
                  <button
                    type="button"
                    className="toggle-senha"
                    onClick={() => setMostrarSenha(s => !s)}
                  >
                    {mostrarSenha ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </div>
            </div>

            <div className="cad-grid-2">
              <div className="form-group">
                <label><FiShield /> Perfil de acesso</label>
                <select name="permissao" value={formData.permissao} onChange={handleInputChange}>
                  <option value="viewer">Visualizador</option>
                  <option value="auxiliar">Auxiliar de Jovens</option>
                  <option value="reuniao_criancas">Reunião de Crianças</option>
                  <option value="editor">Editor</option>
                  <option value="admin">Administrador</option>
                </select>
              </div>
            </div>

            <label className="checkbox-row">
              <input
                type="checkbox"
                name="ativo"
                checked={formData.ativo}
                onChange={handleInputChange}
              />
              <span>Usuário ativo</span>
            </label>

            <div className="form-group" style={{ marginTop: 12 }}>
              <label><FiMail /> E-mail mensal de aniversariantes</label>
              <select
                name="email_aniversariantes_tipo"
                value={formData.email_aniversariantes_tipo}
                onChange={handleInputChange}
              >
                <option value="desativado">Desativado</option>
                <option value="criancas">Somente Crianças (4-12 anos)</option>
                <option value="criancas_jovens">Crianças + Jovens</option>
                <option value="todos">Crianças + Jovens + Adultos</option>
              </select>
              <small className="form-hint">Enviado todo dia 1 com a lista de aniversariantes do mês.</small>
            </div>
          </div>
        </div>

        {/* Permissões granulares */}
        <div className="cad-card">
          <div className="cad-card-header">
            <FiShield /> Permissões por Módulo
            <label className="personalizar-toggle">
              <input
                type="checkbox"
                checked={personalizarPerms}
                onChange={handlePersonalizar}
              />
              <span>Personalizar</span>
            </label>
          </div>
          <div className="cad-card-body">
            {!personalizarPerms && (
              <p className="perm-info">
                Permissões automáticas para o perfil <strong>{
                  formData.permissao === 'admin' ? 'Administrador' :
                  formData.permissao === 'editor' ? 'Editor' :
                  formData.permissao === 'auxiliar' ? 'Auxiliar de Jovens' :
                  formData.permissao === 'reuniao_criancas' ? 'Reunião de Crianças' : 'Visualizador'
                }</strong>. Marque "Personalizar" para ajustar individualmente.
              </p>
            )}

            <div className="perm-table">
              <div className="perm-thead">
                <span>Módulo</span>
                <span>Visualizar</span>
                <span>Editar</span>
              </div>
              {MODULOS.map(m => {
                const perms = modulos[m.key] || { read: false, write: false };
                const disabled = !personalizarPerms;
                return (
                  <div key={m.key} className={`perm-row ${perms.read ? '' : 'row-off'}`}>
                    <span className="perm-modulo">{m.label}</span>
                    <label className="perm-check">
                      <input
                        type="checkbox"
                        checked={perms.read}
                        disabled={disabled || m.key === 'dashboard'}
                        onChange={() => toggleRead(m.key)}
                      />
                      <span className={`check-icon ${perms.read ? 'on' : ''}`}>
                        {perms.read && <FiCheck />}
                      </span>
                    </label>
                    <label className="perm-check">
                      {m.soLeitura ? (
                        <span className="perm-na">—</span>
                      ) : (
                        <>
                          <input
                            type="checkbox"
                            checked={perms.write}
                            disabled={disabled}
                            onChange={() => toggleWrite(m.key)}
                          />
                          <span className={`check-icon ${perms.write ? 'on' : ''}`}>
                            {perms.write && <FiCheck />}
                          </span>
                        </>
                      )}
                    </label>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Ações */}
        <div className="cad-actions">
          <button
            type="button"
            className="btn-cancelar"
            onClick={() => navigate('/usuarios')}
            disabled={loading}
          >
            Cancelar
          </button>
          <button type="submit" className="btn-salvar" disabled={loading}>
            <FiSave /> {loading ? 'Salvando...' : (isEditing ? 'Atualizar' : 'Cadastrar')}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CadastroUsuario;
